import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldPlus, Search, LogIn } from 'lucide-react';

export const LandingScreen = () => {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex-1 bg-slate-50 flex flex-col justify-center p-6 overflow-hidden relative min-h-screen">
      {/* Decorative Background Elements */}
      <div className="absolute top-[-150px] left-[-100px] w-screen h-[100vw] bg-sky-600/5 rounded-full z-0 pointer-events-none" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[80vw] h-[80vw] bg-emerald-600/5 rounded-full z-0 pointer-events-none" />

      <div 
        className="flex-1 flex flex-col justify-between pt-[60px] pb-[40px] max-w-md w-full mx-auto z-10 transition-all duration-700 ease-out"
        style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(30px)',
        }}
      >
        
        <div className="flex-1 flex flex-col justify-center items-center">
          <div className="w-24 h-24 bg-sky-50 rounded-full flex items-center justify-center border border-sky-100 mb-6 shadow-[0_8px_15px_rgba(2,132,199,0.1)]">
            <ShieldPlus size={48} className="text-sky-600" />
          </div>
          
          <h1 className="text-4xl font-extrabold text-slate-900 mb-4 text-center tracking-tight">
            Aura Clínico
          </h1>
          <p className="text-[17px] text-slate-600 text-center leading-relaxed px-5 m-0">
            Encuentra especialistas médicos de confianza y gestiona tu salud en un solo lugar.
          </p>
        </div>

        <div className="w-full flex flex-col gap-4">
          <button 
            onClick={() => navigate('/app')}
            className="w-full h-14 bg-sky-600 text-white rounded-2xl flex items-center justify-center gap-2.5 border-none cursor-pointer text-lg font-bold shadow-[0_6px_12px_rgba(2,132,199,0.25)] transition-opacity hover:opacity-90"
          >
            <Search size={24} className="text-white" />
            Buscar Especialista
          </button>

          <button 
            onClick={() => navigate('/login')}
            className="w-full h-14 bg-white text-sky-600 rounded-2xl flex items-center justify-center gap-2.5 border border-slate-200 cursor-pointer text-lg font-bold shadow-sm transition-colors hover:bg-slate-50"
          >
            <LogIn size={24} className="text-sky-600" />
            Ingresar / Registrarse
          </button>
        </div>

      </div>
    </div>
  );
};
